import React from 'react';
export function ValueSummaryTable() {
  const items = [{
    name: 'Protocolo DOG-CALM™',
    value: '47€',
    isFree: false
  }, {
    name: 'Bono 1: Plan de Lluvia',
    value: 'GRATIS',
    isFree: true
  }, {
    name: 'Bono 2: La Dieta del Foco',
    value: 'GRATIS',
    isFree: true
  }, {
    name: 'Bono 3: El Perro Cafetero',
    value: 'GRATIS',
    isFree: true
  }];
  return <section className="py-10 px-5" data-id="element-349">
      <div className="max-w-lg mx-auto" data-id="element-350">
        <div className="rounded-2xl overflow-hidden border border-white/10" style={{
        backgroundColor: '#0F3C3C'
      }} data-id="element-351">
          {/* Header */}
          <div className="px-6 pt-6 pb-4" data-id="element-352">
            <h3 className="text-lg font-bold text-white text-center" data-id="element-353">
              Lo que incluye tu acceso hoy:
            </h3>
          </div>

          {/* Items */}
          <div className="px-6 space-y-0" data-id="element-354">
            {items.map((item, index) => <div key={index} className="flex items-center justify-between py-3.5 border-b border-white/10 last:border-b-0" data-id="element-355">
                <span className="text-white/80 text-sm font-medium" data-id="element-356">
                  {item.name}
                </span>
                <span className={`text-sm font-bold flex-shrink-0 ml-4 ${item.isFree ? 'text-accent' : 'text-white/50 line-through'}`} data-id="element-357">
                  {item.value}
                </span>
              </div>)}
          </div>

          {/* Total */}
          <div className="px-6 py-5 mt-2" style={{
          backgroundColor: 'rgba(212, 175, 55, 0.15)'
        }} data-id="element-358">
            <p className="text-center font-black text-2xl tracking-tight" style={{
            color: '#D4AF37'
          }} data-id="element-359">
              TODO POR SOLO 9,95€
            </p>
          </div>
        </div>
      </div>
    </section>;
}